import { Injectable } from '@angular/core';
import {RouteConstants} from "../constants/route-constants";
import {CookieService} from "ngx-cookie-service";
import {StorageService} from "./storage.service";

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor(private storageService: StorageService) {}
  redirectToUrl(urlParam: any, isAbsolutePath = false) {
    let urlPath = window.location.origin;
    if ( urlParam) {
      urlPath = isAbsolutePath ? urlParam : window.location.origin + urlParam;
    }

    window.location.href = urlPath;
  }

  goToSignIn() {
    this.storageService.setDeepLink();
    this.redirectToUrl(RouteConstants.external.login.rogers, true);
  }
}
